/**
 * Legal configuration.
 *
 * ⚠️ Hard rules baked into this config:
 *   • NO operator legal-entity name, registration numbers, or registered
 *     address live in this file — they must not surface on the site.
 *   • NO third-party vendor names (KYC / payment / sanctions providers) are
 *     stored in this file. The customer-facing copy refers to them
 *     generically ("our regulated payment partner", "our identity-verification
 *     provider"). Do NOT add vendor names here.
 *   • NO internal monitoring thresholds (reporting amounts, travel-rule
 *     trigger, source-of-funds trigger figure) live in this file — public
 *     pages must never carry those numbers.
 */

export const LEGAL = {
  REVIEWED: true,

  // Customer support
  SUPPORT_EMAIL: "support@xchangely.io",
  COMPLAINTS_EMAIL: "support@xchangely.io",
  DPO_EMAIL: "support@xchangely.io",

  // Effective dates
  TERMS_EFFECTIVE_DATE: "5 February 2026",
  PRIVACY_EFFECTIVE_DATE: "5 February 2026",
  AML_EFFECTIVE_DATE: "5 February 2026",
  WHY_SOF_EFFECTIVE_DATE: "5 February 2026",
  COOKIES_EFFECTIVE_DATE: "5 February 2026",
};

export const isLegalDraft = () => !LEGAL.REVIEWED;

// Single source of truth for the footer compliance block.
export const COMPLIANCE_BLOCK = (
  `Xchangely — a virtual-currency on-ramp · Support: ${LEGAL.SUPPORT_EMAIL}`
);

export const FACILITATION_DISCLOSURE =
  "The virtual IBAN and crypto swap are facilitated through our regulated payment partner.";

export const NON_ADVICE_LINE =
  "This service does not provide investment advice; crypto-asset values can go down as well as up.";
